import { render, staticRenderFns } from "./TravelDashboard.vue?vue&type=template&id=8919887e&scoped=true"
import script from "./TravelDashboard.vue?vue&type=script&lang=js"
export * from "./TravelDashboard.vue?vue&type=script&lang=js"
import style0 from "./TravelDashboard.vue?vue&type=style&index=0&id=8919887e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8919887e",
  null
  
)

export default component.exports